import type { TocItem } from '~/types/toc-item'

export function useArticleDecorator (plainHtmlContent: ComputedRef<string> | Ref<string>) {
  const plainHtml: ComputedRef<string> = computed(() => {
    return plainHtmlContent.value.replaceAll(
      /<h[2-6]>/g,
      (x: string): string => x.replace('>', ` id="${generateId()}">`)
    )
  })

  function getPlainHtml (): string {
    return plainHtml.value
  }

  function getTocItems (): TocItem[] {
    const tocItems: Ref<TocItem[]> = ref([])
    const subHeaders = plainHtml.value.match(/<h[.*->](.*?)<\/h[2-6]>/g)

    if (subHeaders !== null) {
      for (const subHeader of subHeaders) {
        const id = subHeader.match(/id="(.*?)"/)

        if (id === null) {
          continue
        }

        const title = subHeader
          .substring(
            subHeader.indexOf('>') + 1,
            subHeader.lastIndexOf('</')
          )
          .replace(':', '')
          .replace(/<\/?[^>]+>/ig, '')

        tocItems.value.push({ title, href: `#${id[1]}` })
      }
    }

    return tocItems.value
  }

  function generateId (): string {
    return `anchor${Math.random().toString(16).slice(2)}`
  }

  return { getPlainHtml, getTocItems }
}
